import { render, staticRenderFns } from "./impuestos.vue?vue&type=template&id=4d7b4544&scoped=true"
import script from "./impuestos.vue?vue&type=script&lang=js"
export * from "./impuestos.vue?vue&type=script&lang=js"
import style0 from "./impuestos.vue?vue&type=style&index=0&id=4d7b4544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7b4544",
  null
  
)

export default component.exports